import { validate } from "validate.js";
import {isEmpty} from 'lodash'

validate.validators.array = (arrayItems, itemConstraints) => {
  if(!arrayItems){
    return
  }
  const arrayItemErrors = Object.values(arrayItems).reduce((errors, item, index) => {
    let key = ''
    if('email' in item || 'sms' in item){
      key = ('email' in item)?'email':'sms';
    }
   const constrains = itemConstraints[key];
    const error = validate(item, {[key]: constrains})
    if (error) errors[item.id] = error;
    return errors
  }, {})
  return isEmpty(arrayItemErrors) ? null : arrayItemErrors;
}

const validators = {
  email: {
    email: {
      message: "^errors.register.invalid_email"
    }
  },
  user_name: {
    email: {
      message: "^errors.register.invalid_email"
    }
  },
  first_name: {
    length: {
      minimum: 2,
      message: "^errors.register.invalid_first_name"
    }
  },
  last_name: {
    length: {
      minimum: 2,
      message: "^errors.register.invalid_last_name"
    }
  },
  password: {
    length: {
      minimum: 6,
      message: "^errors.register.password_to_short"
    }
  },
  accepted_terms: {
    // presence: {
    //   message: "^errors.register.accept_terms"
    // },
    inclusion: {
      within: [true],
      message: "^errors.register.accept_terms"
    }
  },     
  address: {
    length: {
      minimum: 5,
      message: "^b2b.add_location"
    }
  },    
  friends:{
    array: {
      email:{
        presence: true,         
        email: {
          message: "^errors.register.invalid_email"
        }
      },
      sms: {
        presence: true,
        length: {
          minimum: 5,
          message: "^b2b.invalid_phone_number" 
        }
      }
    }    
  }
  
};

export default validators;
